import { Box, Icon, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.shadedown_20,
    minHeight: '70px',
    width: 'calc(100% - 20px)',
    margin: '10px',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  left: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginLeft: '8px',
    fontSize: 16,
    fontWeight: 'bold',
    flex: 1,
    width: '100%',
    height: '100%',
    border: '0px solid #ff0000',
    marginRight: '8px',
    overflow: 'hidden',
    marginTop: '10px',
    textAlign: 'left',
  },
  right: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    marginRight: '8px',
  },
}));

function truncate(source, size) {
  return source.length > size ? source.slice(0, size - 1) + '…' : source;
}

const EventStartEditor = withRouter((props) => {
  const classes = useStyles();
  const [adjustedstartoffset, setAdjustedStartOffset] = useState(0);
  console.log('props.event', props.event);
  useEffect(() => {
    if (props.event) {
      console.log('event', props.event);
      console.log('props.playerPositionUtc', props.playerPositionUtc);
      //starttimedate_utc already includes adjusted_start_offset, need to remove it before calc.
      let timediff = Number(
        props.playerPositionUtc -
          Number(
            props.event.starttimedate_utc - props.event.adjusted_start_offset
          )
      ).toFixed(0);
      console.log('timediff', timediff);
      setAdjustedStartOffset(timediff);
    }
  }, [props.playerPositionUtc]);

  const saveAdjustedStartOffset = async (offset) => {
    await axios.post(
      `/api/visitor/rooms/${props.event.programRoomId}/setadjustedstartoffset`,
      {
        eventId: props.event.id,
        offset: offset,
      }
    );
    window.history.pushState(null, null, window.location.pathname);
    location.reload();
  };

  return (
    props.event && (
      <Box className={classes.root}>
        <div className={classes.container}>
          <div className={classes.left}>
            <Box>
              <Box component="div" sx={{ overflow: 'hidden' }}>
                Editing session: {truncate(props.event.title, 30)}
              </Box>
              <Box>
                Use button(SET START HERE) to set start position for session at
                player location.
              </Box>
            </Box>
          </div>
          <div className={classes.right}>
            <Box>
              <Button
                startIcon={<Icon>start</Icon>}
                variant="contained"
                size="small"
                color="primary"
                disabled={false}
                onClick={() => saveAdjustedStartOffset(adjustedstartoffset)}
              >
                Set start here
              </Button>
            </Box>
            <Box ml={1}>
              <Button
                startIcon={<Icon>clear</Icon>}
                variant="contained"
                size="small"
                color="primary"
                disabled={false}
                onClick={() => saveAdjustedStartOffset(0)}
              >
                Reset
              </Button>
            </Box>
          </div>
        </div>
      </Box>
    )
  );
});

export default EventStartEditor;
